import {Controller} from '@hotwired/stimulus';

/**
 * Tuile « Tags » d'un formulaire d'édition : son libellé résume les tags saisis dans le champ de chaque langue
 * (« coton · été »), `empty` à défaut. Un libellé et un champ par langue, reliés par `data-lang`. Un tag proposé
 * (`.js-tag`, sous le champ de sa langue) disparaît tant qu'il figure dans le champ, et revient s'il en est retiré :
 * `d-none`, que les `show()` du filtrage des suggestions ne lèvent pas.
 *
 * Un tag proposé s'ajoute au champ par le script des suggestions, qui arrête le clic et ne déclenche pas d'événement
 * natif : le clic est pris à la capture et le champ relu une fois rempli.
 *
 *   <div {{ stimulus_controller('tags-tile', {empty: '…'}) }}
 *        data-action="input->tags-tile#refresh click->tags-tile#refreshSoon:capture">
 *     <span data-lang="fr" {{ stimulus_target('tags-tile', 'label') }}>…</span>
 *     <input data-lang="fr" {{ stimulus_target('tags-tile', 'field') }}>
 */
export default class extends Controller {
  static targets = ['label', 'field'];

  static values = {empty: String};

  connect() {
    this.refresh();
  }

  refresh() {
    this.fieldTargets.forEach((field) => {
      const tags = field.value.split(',').map((tag) => tag.trim()).filter((tag) => tag !== '');
      const label = this.labelTargets.find((candidate) => candidate.dataset.lang === field.dataset.lang);

      if (label) {
        label.textContent = tags.length > 0 ? tags.join(' · ') : this.emptyValue;
      }

      field.closest('.form-field')?.querySelectorAll('.js-tag').forEach((suggestion) => {
        const added = tags.includes(suggestion.textContent.trim());

        // ajouté au clavier, le tag masqué emporterait le focus : il revient au champ
        if (added && document.activeElement === suggestion) {
          field.focus();
        }

        suggestion.classList.toggle('d-none', added);
      });
    });
  }

  refreshSoon() {
    setTimeout(() => this.refresh());
  }
}
